import { Button } from "@repo/ui";
import { Loader2 } from "lucide-react";

const PAGE_SIZE = 10;

export type PaginationStatus =
  | "LoadingFirstPage"
  | "CanLoadMore"
  | "LoadingMore"
  | "Exhausted";

/**
 * Bouton « Charger plus » pour la pagination curseur (usePaginatedQuery).
 * Pas de « page X/Y » : la pagination indexée ne fournit pas de total (§7).
 */
export function LoadMore({
  status,
  loadMore,
  count,
}: {
  status: PaginationStatus;
  loadMore: (numItems: number) => void;
  count: number;
}) {
  if (status === "LoadingFirstPage") return null;

  return (
    <div className="flex flex-col items-center gap-2 mt-6">
      <span className="text-sm text-muted-foreground">
        {count} élément(s) affiché(s)
      </span>
      {status === "CanLoadMore" || status === "LoadingMore" ? (
        <Button
          variant="outline"
          disabled={status === "LoadingMore"}
          onClick={() => loadMore(PAGE_SIZE)}
        >
          {status === "LoadingMore" ? (
            <>
              <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              Chargement...
            </>
          ) : (
            "Charger plus"
          )}
        </Button>
      ) : null}
    </div>
  );
}
